import { NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { ViewType } from '../../types/view-type.model'

@Component({
  selector: 'dhp-toggle-view',
  templateUrl: './toggle-view.component.html',
  styleUrls: ['./toggle-view.component.css'],
  imports: [NgClass, TranslatePipe],
})
export class ToggleViewComponent {
  readonly viewType = input<ViewType>('list')
  readonly viewTypeChange = output<ViewType>()

  toggleView(view: ViewType): void {
    if (this.viewType() !== view) {
      this.viewTypeChange.emit(view)
    }
  }
}
